import { withStyles, WithStyles } from "@mui/styles";
import { DashboardStyleClasses } from "assets/jss/common-styles";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiPaper from "components/MuiExtras/MuiPaper";
import { DashboardConsumptionSummaryColumn } from "models/ApiModels";
import * as React from "react";
import { ConsumptionAnalysisStorageGraph } from "views/Dashboards/ConsumptionAnalysisDashboard/ConsumptionAnalysisStorage";
import ConsumptionAnalysisTiles from "views/Dashboards/ConsumptionAnalysisDashboard/ConsumptionAnalysisTiles";
import { ConsumptionAnalysisUsersGraph } from "views/Dashboards/ConsumptionAnalysisDashboard/ConsumptionAnalysisUsers";
import { WithTranslation, withTranslation } from "react-i18next";

/////////////////////////////////////////////////////////////////////////////////////

interface IState {
    activeTitle: DashboardConsumptionSummaryColumn;
}

export type CommonProps = WithStyles<typeof DashboardStyleClasses> & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class ConsumptionAnalysisDashboard extends React.PureComponent<CommonProps, IState> {

    constructor(props: CommonProps) {
        super(props);

        this.state = {
            activeTitle: DashboardConsumptionSummaryColumn.Users,
        };
    }

    /////////////////////////////////////////////////////////////////////////////////////

    render() {
        const { activeTitle } = this.state;


        return (
            <div className={this.props.classes.dashboardLargeContainer}>

                <ConsumptionAnalysisTiles
                    {...this.props}
                    activeTile={activeTitle}
                    onChange={
                        (tile) => {
                            this.setState({ activeTitle: tile });
                        }
                    }
                />

                <MuiContainer margin="normal">
                    <MuiPaper borderVariant="accentedRound" borderColor="warning">

                        {
                            activeTitle == DashboardConsumptionSummaryColumn.Users
                                ? <ConsumptionAnalysisUsersGraph tile={activeTitle} {...this.props} />
                                : activeTitle == DashboardConsumptionSummaryColumn.Storage
                                    ? <ConsumptionAnalysisStorageGraph tile={activeTitle} {...this.props}/>
                                    : null
                        }

                    </MuiPaper>
                </MuiContainer>

            </div>
        );
    }
}

export default withTranslation()(withStyles(DashboardStyleClasses)(ConsumptionAnalysisDashboard));